import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Practice } from 'src/app/models/practice';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import {MatDialog} from '@angular/material/dialog';
import { InviteMemberComponent } from 'src/app/components/modals/invite-member/invite-member.component';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-practice-members',
  templateUrl: './practice-members.component.html',
  styleUrls: ['./practice-members.component.scss']
})
export class PracticeMembersComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;
  public datasource:MatTableDataSource<any>;
  displayedColumns: string[] = ['first_name', 'last_name', 'email','mentor', 'status', 'toggleStatus', 'remove'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  public first_name:string='';
  public last_name:string='';
  public email:string='';
  public seats;
  public quantity:number=0;
  public cancelledActiveSeats;
  public cancelledActiveQuantity:number=0;
  public activeMembers:number=0;
  public bacsSeats:number=0;

  constructor(
    public dialog: MatDialog,
    private _practice: PracticeService,
    private _route: ActivatedRoute,
    private _notify: NotificationService,
    private _router: Router
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
        this.datasource = new MatTableDataSource<any>(this.practice.members);
        this.datasource.paginator=this.paginator;
        this.calculateSeats();
        this.calculateActiveMembers();
      }
    );
  }

  public calculateActiveMembers(){
    this.activeMembers=0;
    this.practice.members.forEach(member=>{
      if(member.practice_status) this.activeMembers++;
    });
  }

  public calculateSeats(){
    this.seats=0;
    this.quantity=0;
    this.cancelledActiveQuantity=0;
    if(this.practice.is_bacs_enabled==1)
    {
      this.bacsSeats=this.practice.bacs_seats;
    }
    this.practice.owner.subscriptions.forEach(sub=>{
      if(
        new Date(sub.sub_until).getTime() > new Date().getTime()
        && (
          sub.plan.stripe_reference == 'annual_seats'
          || sub.plan.stripe_reference == 'monthly_seats')
        && sub.status=='active'
      ) {
        this.seats=sub;
        this.quantity=sub.quantity;
      }
      if(
        new Date(sub.sub_until).getTime() > new Date().getTime()
        && (
          sub.plan.stripe_reference == 'annual_seats'
          || sub.plan.stripe_reference == 'monthly_seats')
        && sub.status!='active'
        && sub.status!='incomplete'
      ) {
        this.cancelledActiveSeats=sub;
        this.cancelledActiveQuantity+=sub.quantity;
      }
    });
  }

  public goToMember(member){
    this._router.navigate(['/members/'+member.id]);
  }

  public removeMember(id:number){
    if(confirm("Confirm removal of this member from the Practice.")){
      this._practice.removeUser(id).subscribe(
        res=>{
          this._notify.showMessage('Practice member removed.', 'OK');
          this.getPractice();
        }
      );
    }
  }

  public toggleStatus(id:number, status){
    if((this.cancelledActiveQuantity+this.quantity+20+this.bacsSeats <= this.activeMembers)&&status<1){
      return alert('Not enough available seats to activate another user. Deactivate some members or ask the Practice to create/update their seat subscription before continuing.');
    }
    this._practice.toggleUser(id).subscribe(
      res=>{
        this.getPractice();
      }
    );
  }

  ngOnInit() {
    this.getPractice();

  }

  ngAfterViewInit(){

  }

  public inviteMember(){
    const dialogRef = this.dialog.open(InviteMemberComponent, {
      width: '350px',
      data: {practice: this.practice},
      panelClass: 'ng-modal-custom'
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this._notify.showMessage('New member invited.', 'OK');
        this.getPractice();
      }
    });
  }

  public cancelInvite(id:number){
    if(confirm("are you sure that you want to revoke this invitation?")){
      this._practice.revokeInvite(this.practiceId, id).subscribe(
        (res:any)=>{
          if(res.message) {
            this._notify.showMessage(res.message, 'OK');
            this.getPractice();
          }
        }
      );
    }
  }

  public resendInvite(inviteId:number){
    this._practice.reinvitePracticeMember(inviteId).subscribe(
      res=>{
        this._notify.showMessage(res.message, 'OK');
      }
    );
  }

  filterEvent(column,value) {
    this[column]=value;
    console.log(this[column]);
    console.log(this.practice.members);

    this.datasource = new MatTableDataSource<any>(this.practice.members.filter(member=>{
      return (
        ((this.first_name != '' && member.first_name.toLowerCase().indexOf(this.first_name.toLowerCase()) > -1) || this.first_name == '')
        && ((this.last_name != '' && member.last_name.toLowerCase().indexOf(this.last_name.toLowerCase()) > -1) || this.last_name == '')
        && ((this.email != '' && member.email.toLowerCase().indexOf(this.email.toLowerCase()) > -1) || this.email == '')
      );
    }));
    this.datasource.paginator=this.paginator;
  }

}
